import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Saraswathi from '../../assets/Rehab staff/Saraswathi.JPG';
import Malathi from '../../assets/Rehab staff/Malathi.JPG';
import Sumalatha from '../../assets/Rehab staff/Sumalatha.JPG';
import Harish from '../../assets/Rehab staff/Haresh kumar.JPG';
import Devamani from '../../assets/Rehab staff/Devamani.JPG';
import Hemalatha from '../../assets/Rehab staff/Hemalatha.JPG';

const teamMembers = [
  {
    name: "P. Hemalatha",
    role: "Principal",
    bio: "Experienced educator dedicated to special needs education.",
    image: Hemalatha,
  },
  {
    name: "B. Devamani",
    role: "Special Educator",
    bio: "Passionate about fostering inclusive learning environments.",
    image: Devamani,
  },
  {
    name: "M. Harish",
    role: "Special Educator",
    bio: "Committed to supporting students with diverse learning needs.",
    image: Harish,
  },
  {
    name: "S. Sumalatha",
    role: "Special Educator",
    bio: "Dedicated to empowering students through tailored education.",
    image: Sumalatha,
  },
  {
    name: "Y. Saraswathi",
    role: "Special Educator",
    bio: "Focused on enhancing student development and independence.",
    image: Saraswathi,
  },
  {
    name: "E. Malathi",
    role: "Special Educator",
    bio: "Enthusiastic about creating engaging learning experiences.",
    image: Malathi,
  },
];

const sections = [
  {
    title: 'Day School Services',
    items: [
      {
        heading: 'Special Education Program',
        content: 'Our special education program is tailored to meet the unique needs of individuals with neurodevelopmental disorders, including Autism Spectrum Disorder (ASD), Attention Deficit Hyperactivity Disorder (ADHD), and Intellectual Disability.'
      },
      {
        heading: 'Individualized Education Plans (IEPs)',
        content: 'We develop and implement IEPs that cater to the specific needs and goals of each student, ensuring a personalized approach to education.'
      },
      {
        heading: 'Therapeutic Services',
        content: 'Our students have access to a range of therapeutic services, including speech therapy, occupational therapy, and physical therapy, to support their overall development.'
      },
      {
        heading: 'Academic Support',
        content: 'We provide academic support to help students with learning difficulties, including math, reading, and writing.'
      },
      {
        heading: 'Life Skills Training',
        content: 'Our program includes life skills training to promote independence, self-care, and social skills.'
      }
    ]
  },
  {
    title: 'Residential Services',
    items: [
      {
        heading: '24-Hour Care',
        content: 'Our residential program provides 24-hour care and supervision, ensuring the safety and well-being of our students.'
      },
      {
        heading: 'Residential Therapies',
        content: 'Our students have access to a range of therapies, including speech therapy, occupational therapy, and physical therapy, to support their overall development.'
      },
      {
        heading: 'Structured Daily Routine',
        content: 'Our residential program provides a structured daily routine, including academic, therapeutic, and recreational activities.'
      },
      {
        heading: 'Nursing Care',
        content: 'We provide daily nursing care under the supervision of a psychiatric doctor.'
      },
      {
        heading: 'Food',
        content: 'We provide a delicious meal plan designed under the supervision of a nutritionist.'
      },
      {
        heading: 'Life Skills Training',
        content: 'Our program includes life skills training to promote independence, self-care, and social skills.'
      },
      {
        heading: 'Family Support',
        content: 'We provide support and counseling to families, addressing emotional and psychological needs.'
      }
    ]
  },
  {
    title: 'Specialized Programs',
    items: [
      {
        heading: 'Autism Spectrum Disorder (ASD) Program',
        content: 'Our ASD program is designed to meet the unique needs of individuals with autism, including social skills training, communication support, and behavioral interventions.'
      },
      {
        heading: 'Attention Deficit Hyperactivity Disorder (ADHD) Program',
        content: 'Our ADHD program provides academic support, behavioral interventions, and strategies to help individuals manage their symptoms and achieve success.'
      },
      {
        heading: 'Intellectual Disability Program',
        content: 'Our intellectual disability program offers a supportive and inclusive environment, promoting academic, social, and emotional growth.'
      }
    ]
  }
];

const SpecialSchool = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (

    <div>

      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Special School for Neurodevelopmental Disorders</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Special School at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            At our esteemed institution, we offer a dedicated Special School tailored to support children and young individuals with neurodevelopmental disorders including Autism Spectrum Disorder (ASD), ADHD, and Intellectual Disability. Our programs are designed to foster independence, social skills, and academic development in a nurturing environment.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering high-quality, individualized services that cater to the unique needs of individuals with neurodevelopmental disorders. Our team is passionate about creating a supportive and inclusive environment that fosters growth, development, and empowerment.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To know more about our <strong>Special School for Neurodevelopmental Disorders</strong> or to schedule an appointment, click below and fill out our appointment request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>
  );
};

export default SpecialSchool;
